import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { checkoutLockMessage, parseInvitationApiError } from "./paymentInvitation";
import { planInvitationsQueryKey } from "./useAdminPlanInvitations";

export function useCancelPlanInvitation() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: ["admin", "experts", "plan-invitations", "cancel"],
    mutationFn: ({ expertId, invitationId }: { expertId: number; invitationId: number }) => (
      api.admin.expertBilling.cancelPlanInvitation({
        params: { expert: expertId, planInvitation: invitationId },
      })
    ),
    onSuccess: (_invitation, variables) => {
      queryClient.invalidateQueries({ queryKey: planInvitationsQueryKey(variables.expertId) });
      toaster.create({ title: "Payment invitation cancelled", type: "success" });
    },
    onError: (error: Error) => {
      toaster.create({
        title: checkoutLockMessage(error) ? "Invitation is temporarily locked" : "Failed to cancel invitation",
        description: checkoutLockMessage(error) ?? parseInvitationApiError(error).message ?? "An unexpected error occurred",
        type: "error",
      });
      console.error("[useCancelPlanInvitation] Error:", error);
    },
  });

  return mutation;
}

export default useCancelPlanInvitation;
